
import { RichUtils } from "draft-js";
import { createToolbarButtons } from "../createToolbarButtons";
import { inlineStyleMap } from "./inlineStyleMap";
import { BoldButton } from "./BoldButton";
import { ItalicButton } from "./ItalicButton";
import { StriketroughButton } from "./StriketroughButton";
import { CodeButton } from "./CodeButton";

const defaultOptions = {
	buttons: ['bold', 'italic', 'strike', 'code', 'spliter'],
};

const BUTTON_MAP = {
	bold: BoldButton,
	italic: ItalicButton,
	strike: StriketroughButton,
	code: CodeButton,
};


/**
 * @returns {DraftEditorPlugin}
 */
export function createInlineStylePlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };

	return {
		name: 'inline-style',

		getToolbarButtons(props) {
			return createToolbarButtons(BUTTON_MAP, options.buttons, props);
		},

		handleCommand({ getEditorState, setEditorState }, command) {
			if (!['bold', 'italic', 'underline', 'code'].includes(command)) {
				return 'not-handled';
			}
			const editorState = getEditorState();
			// 代码块不支持内联样式
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return 'not-handled';
			}
			return setEditorState(RichUtils.handleKeyCommand(editorState, command)), 'handled';
		},

		getCustomStyleMap() {
			return inlineStyleMap;
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/inlineStylePlugin/createInlineStylePlugin.js